// extracted by mini-css-extract-plugin
export default {"badge":"AdminBadge-module__badge--CFWNn","bordered":"AdminBadge-module__bordered--xyv9E"};